import type { LookupGroup, LookupUser } from './lookupTypes';

export function formatUserDisplayName(user: Pick<LookupUser, 'firstName' | 'lastName' | 'email' | 'id'>): string {
  const name = `${user.firstName || ''} ${user.lastName || ''}`.trim();
  return name || user.email || user.id;
}

export function formatGroupDisplayName(group: Pick<LookupGroup, 'name' | 'id'>): string {
  return group.name || group.id;
}

export function userMatchesSearch(user: LookupUser, search: string): boolean {
  const q = search.trim().toLowerCase();
  if (!q) return true;
  const haystack = [
    user.firstName,
    user.lastName,
    user.email,
    user.title,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return haystack.includes(q);
}

export function groupMatchesSearch(group: LookupGroup, search: string): boolean {
  const q = search.trim().toLowerCase();
  if (!q) return true;
  const haystack = [group.name, group.description, group.type].filter(Boolean).join(' ').toLowerCase();
  return haystack.includes(q);
}
